import { forwardRef, type ComponentProps } from 'react';
import { TextField } from '@frontend/design-system';

export const PIN_LENGTH = 4;

type PinFieldProps = Omit<ComponentProps<typeof TextField>, 'type'> & {
  length?: number;
};

export const PinField = forwardRef<HTMLDivElement, PinFieldProps>(
  ({ length = PIN_LENGTH, maxLength = length, ...props }, ref) => {
    const { transformValue, ...rest } = props as PinFieldProps & { transformValue?: unknown };
    return <TextField {...rest} ref={ref} type='password' pattern='[0-9]*' autoComplete='off' maxLength={maxLength} />;
  }
);

PinField.displayName = 'PinField';
